/**
 * Base big query parameters to be part of any reported event.
 *
 * @type {Object}
 */
export const BASE_BIG_QUERY_PARAMS = {
    group: 'notifications',
    entity: 'client',
};
